import React from 'react'
import { motion } from 'framer-motion'
import { Leaf, Droplets, Home, TrendingUp } from 'lucide-react'
export function ImpactSection() {
  const metrics = [
    {
      icon: <Leaf className="h-8 w-8" />,
      value: '100%',
      label: 'Renewable Energy',
      desc: 'Zero emissions during operation',
    },
    {
      icon: <Droplets className="h-8 w-8" />,
      value: '24/7',
      label: 'Power Availability',
      desc: 'Consistent baseload generation',
    },
    {
      icon: <Home className="h-8 w-8" />,
      value: '50k+',
      label: 'Homes Powered',
      desc: 'Projected capacity per installation',
    },
    {
      icon: <TrendingUp className="h-8 w-8" />,
      value: '40%',
      label: 'Cost Reduction',
      desc: 'Target LCOE reduction by 2030',
    },
  ]
  return (
    <section
      id="impact"
      className="py-24 bg-navy-900 text-white relative overflow-hidden"
    >
      {/* Background Texture */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#088395_1px,transparent_1px)] [background-size:16px_16px]" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-16">
          <div>
            <h2 className="text-ocean-500 font-semibold tracking-wider uppercase text-sm mb-3">
              Impact & Sustainability
            </h2>
            <h3 className="text-3xl md:text-4xl font-bold mb-6">
              Driving the Blue Economy
            </h3>
            <p className="text-gray-300 text-lg leading-relaxed mb-6">
              Our mission extends beyond electricity. By providing reliable
              clean energy, we enable sustainable economic growth for coastal
              communities, support desalination projects for fresh water, and
              protect our oceans from the impacts of climate change.
            </p>
            <a
              href="#projects"
              className="text-ocean-500 font-semibold hover:text-white transition-colors inline-flex items-center"
            >
              View our sustainability report <span className="ml-2">→</span>
            </a>
          </div>

          <div className="grid grid-cols-2 gap-6">
            {metrics.map((metric, index) => (
              <motion.div
                key={index}
                initial={{
                  opacity: 0,
                  scale: 0.9,
                }}
                whileInView={{
                  opacity: 1,
                  scale: 1,
                }}
                viewport={{
                  once: true,
                }}
                transition={{
                  delay: index * 0.1,
                  duration: 0.5,
                }}
                className="bg-navy-800/50 backdrop-blur-sm border border-white/10 p-6 rounded-xl"
              >
                <div className="text-ocean-500 mb-4">{metric.icon}</div>
                <div className="text-3xl font-bold text-white mb-1">
                  {metric.value}
                </div>
                <div className="text-sm font-semibold text-gray-300 mb-2">
                  {metric.label}
                </div>
                <p className="text-xs text-gray-400">{metric.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
